import { Div, Collection, RefBool, Line} from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { Icons } from "./Icons";
import { SvgButton } from "./SvgButton";
import { Box } from "./Box";
import { ChevronButton } from "./ChevronButton";


export class CollectionItemPrinter<T> extends Div
{
    private foldBtnVisible = new RefBool()
    private contentVisible = new RefBool()
    protected Content = new Div("")

    constructor(item: T, collection: Collection<T>, titleContent?: appendable[])
    {
        super("SwapableEntryEdit");

        const entryControlSection = new Div()//.FloatRight()
            .Append(
                new ChevronButton(this.contentVisible)
                    .Visible(this.foldBtnVisible),

                collection.CanSwapUp(item) && new SvgButton(Icons.ArrowUp, () => collection.SwapUp(item)),
                collection.CanSwapDown(item) && new SvgButton(Icons.ArrowDown, () => collection.SwapDown(item)),

                new SvgButton(Icons.X, () =>
                {
                    if (confirm(`Usunąć te sekcje?`))
                        collection.Remove(item)
                }),
            )

        this.Append(
            new Div("header").Append(
            titleContent && new Box(...titleContent)
                .OnClick(() => this.contentVisible.Toggle()).Class("title"),
            entryControlSection,
            ),
            this.Content.Visible(this.contentVisible, "block"),
        )
    }

    public AddContent(...content: appendable[]): this
    {
        this.Content.Append(...content);
        this.foldBtnVisible.value = this.Content.Children.Count > 0;

        return this;
    }
}
